//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import create from "../../create";
export default create({
  name: "video",
  data: function data() {
    return {};
  },
  computed: {
    params: function params() {
      var result = {};
      if (this.option.controls) result.controls = "controls";
      if (this.option.loop) result.loop = "loop";
      if (this.option.autoplay) result.autoplay = "autoplay";
      return result;
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    handleClick: function handleClick() {
      this.clickFormatter && this.clickFormatter({
        type: index,
        item: item,
        value: item.value,
        data: this.dataChart
      }, this.getItemRefs());
    }
  },
  props: {
    option: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});